<template>
  <!-- Top navigation -->
  <DetailTopNav :heading="this.viewType" :subheading="this.assetType" />

  <!-- Range -->
  <div class="position-absolute v-content d-flex align-items-center text-center z-1" v-if="viewType == 'range' || viewType == 'renders' && this.assetTypesReady === true">
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img :src="theme.cdnUrl + '/assets/' + assetType + '/' + viewType + '/' + this.assetTypes[this.order].LinkName" class="h-100">
        </div>
      </div>
    </div>
  </div>

  <!-- Floorplans -->
  <div class="position-absolute v-content d-flex align-items-center text-center z-1" v-if="viewType == 'floorplans' && this.assetTypesReady === true">
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img :src="theme.cdnUrl + '/assets/' + assetType + '/' + viewType + '/' + this.assetTypes[this.order].LinkName" class="h-100">
        </div>
      </div>
    </div>
  </div>

  <!-- Panoramas -->
  <div class="position-absolute v-content d-flex align-items-center text-center z-1" v-if="viewType == 'panoramas' || viewType == 'virtual-tour' || viewType == 'balcony-views' && this.assetTypesReady === true">
    <iframe :src="this.assetTypes[this.order].url" :title="this.assetTypes[this.order].title" width="100%" height="100%" allow="fullscreen"></iframe>
  </div>

  <!-- Brochures -->
  <div id="pdf-view-inline"></div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from '@/components/DetailTopNav.vue'
import OffCanvas from "@/components/OffCanvas.vue"
import global from "../global"
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetViewDetail",
  props: [
    'assetType',
    'viewType',
    'order'
  ],
  components: {
    DetailTopNav,
    OffCanvas
  },
  data() {
    return {
        assetTypes: null,
        assetOrder: null,
        currentAsset: null,
        folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/' + this.assetType + '/' + this.viewType + '/'),
        currentIndex: null,
        assetNames: null,
        assetUrls: null,
        componentName: "AssetView",
        assetTypesReady: false,
        adobeApiPDFReady: false,
        adobeDCView: null,
    }
  },
  created() {
    if (this.assetType === 'Metaluxe Showcase') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.metaluxeAsset.videos
        this.assetNames = this.theme.metaluxeAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.metaluxeAsset.floorplans
        this.assetNames = this.theme.metaluxeAsset.floorplansName
        this.assetUrls = this.theme.metaluxeAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.metaluxeAsset.panoramas
        this.assetNames = this.theme.metaluxeAsset.panoramasName
        this.assetUrls = this.theme.metaluxeAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.metaluxeAsset.balcony
        this.assetNames = this.theme.metaluxeAsset.balconyName
        this.assetUrls = this.theme.metaluxeAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.metaluxeAsset.renders
        this.assetNames = this.theme.metaluxeAsset.rendersName
        this.assetUrls = this.theme.metaluxeAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.metaluxeAsset.range
        this.assetNames = this.theme.metaluxeAsset.rangeName
        this.assetUrls = this.theme.metaluxeAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.metaluxeAsset.pdf
        this.assetNames = this.theme.metaluxeAsset.pdfName
        this.assetUrls = this.theme.metaluxeAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.metaluxeAsset.videos
        this.assetNames = this.theme.metaluxeAsset.videosName
      }
    } else if (this.assetType === 'Tower Teaser 10k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.towerAsset.videos
        this.assetNames = this.theme.towerAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.towerAsset.floorplans
        this.assetNames = this.theme.towerAsset.floorplansName
        this.assetUrls = this.theme.towerAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.towerAsset.panoramas
        this.assetNames = this.theme.towerAsset.panoramasName
        this.assetUrls = this.theme.towerAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.towerAsset.balcony
        this.assetNames = this.theme.towerAsset.balconyName
        this.assetUrls = this.theme.towerAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.towerAsset.renders
        this.assetNames = this.theme.towerAsset.rendersName
        this.assetUrls = this.theme.towerAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.towerAsset.range
        this.assetNames = this.theme.towerAsset.rangeName
        this.assetUrls = this.theme.towerAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.towerAsset.pdf
        this.assetNames = this.theme.towerAsset.pdfName
        this.assetUrls = this.theme.towerAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.towerAsset.videos
        this.assetNames = this.theme.towerAsset.videosName
      }
    } else if (this.assetType === 'Florian (Full Package) 75k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.florianAsset.videos
        this.assetNames = this.theme.florianAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.florianAsset.floorplans
        this.assetNames = this.theme.florianAsset.floorplansName
        this.assetUrls = this.theme.florianAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.florianAsset.panoramas
        this.assetNames = this.theme.florianAsset.panoramasName
        this.assetUrls = this.theme.florianAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.florianAsset.balcony
        this.assetNames = this.theme.florianAsset.balconyName
        this.assetUrls = this.theme.florianAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.florianAsset.renders
        this.assetNames = this.theme.florianAsset.rendersName
        this.assetUrls = this.theme.florianAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.florianAsset.range
        this.assetNames = this.theme.florianAsset.rangeName
        this.assetUrls = this.theme.florianAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.florianAsset.pdf
        this.assetNames = this.theme.florianAsset.pdfName
        this.assetUrls = this.theme.florianAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.florianAsset.videos
        this.assetNames = this.theme.florianAsset.videosName
      }
    } else if (this.assetType === 'Big Concept 30k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.conceptAsset.videos
        this.assetNames = this.theme.conceptAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.conceptAsset.floorplans
        this.assetNames = this.theme.conceptAsset.floorplansName
        this.assetUrls = this.theme.conceptAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.conceptAsset.panoramas
        this.assetNames = this.theme.conceptAsset.panoramasName
        this.assetUrls = this.theme.conceptAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.conceptAsset.balcony
        this.assetNames = this.theme.conceptAsset.balconyName
        this.assetUrls = this.theme.conceptAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.conceptAsset.renders
        this.assetNames = this.theme.conceptAsset.rendersName
        this.assetUrls = this.theme.conceptAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.conceptAsset.range
        this.assetNames = this.theme.conceptAsset.rangeName
        this.assetUrls = this.theme.conceptAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.conceptAsset.pdf
        this.assetNames = this.theme.conceptAsset.pdfName
        this.assetUrls = this.theme.conceptAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.conceptAsset.videos
        this.assetNames = this.theme.conceptAsset.videosName
      }
    } else if (this.assetType === 'Hospital Teaser 10k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.hospitalAsset.videos
        this.assetNames = this.theme.hospitalAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.hospitalAsset.floorplans
        this.assetNames = this.theme.hospitalAsset.floorplansName
        this.assetUrls = this.theme.hospitalAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.hospitalAsset.panoramas
        this.assetNames = this.theme.hospitalAsset.panoramasName
        this.assetUrls = this.theme.hospitalAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.hospitalAsset.balcony
        this.assetNames = this.theme.hospitalAsset.balconyName
        this.assetUrls = this.theme.hospitalAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.hospitalAsset.renders
        this.assetNames = this.theme.hospitalAsset.rendersName
        this.assetUrls = this.theme.hospitalAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.hospitalAsset.range
        this.assetNames = this.theme.hospitalAsset.rangeName
        this.assetUrls = this.theme.hospitalAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.hospitalAsset.pdf
        this.assetNames = this.theme.hospitalAsset.pdfName
        this.assetUrls = this.theme.hospitalAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.hospitalAsset.videos
        this.assetNames = this.theme.hospitalAsset.videosName
      }
    } else if (this.assetType === 'Residential Teaser 10k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.residentialAsset.videos
        this.assetNames = this.theme.residentialAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.residentialAsset.floorplans
        this.assetNames = this.theme.residentialAsset.floorplansName
        this.assetUrls = this.theme.residentialAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.residentialAsset.panoramas
        this.assetNames = this.theme.residentialAsset.panoramasName
        this.assetUrls = this.theme.residentialAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.residentialAsset.balcony
        this.assetNames = this.theme.residentialAsset.balconyName
        this.assetUrls = this.theme.residentialAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.residentialAsset.renders
        this.assetNames = this.theme.residentialAsset.rendersName
        this.assetUrls = this.theme.residentialAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.residentialAsset.range
        this.assetNames = this.theme.residentialAsset.rangeName
        this.assetUrls = this.theme.residentialAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.residentialAsset.pdf
        this.assetNames = this.theme.residentialAsset.pdfName
        this.assetUrls = this.theme.restaurantAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.residentialAsset.videos
        this.assetNames = this.theme.residentialAsset.videosName
      }
    } else if (this.assetType === 'Restaurant Teaser 10k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.restaurantAsset.videos
        this.assetNames = this.theme.restaurantAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.restaurantAsset.floorplans
        this.assetNames = this.theme.restaurantAsset.floorplansName
        this.assetUrls = this.theme.restaurantAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.restaurantAsset.panoramas
        this.assetNames = this.theme.restaurantAsset.panoramasName
        this.assetUrls = this.theme.restaurantAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.restaurantAsset.balcony
        this.assetNames = this.theme.restaurantAsset.balconyName
        this.assetUrls = this.theme.restaurantAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.restaurantAsset.renders
        this.assetNames = this.theme.restaurantAsset.rendersName
        this.assetUrls = this.theme.restaurantAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.restaurantAsset.range
        this.assetNames = this.theme.restaurantAsset.rangeName
        this.assetUrls = this.theme.restaurantAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.restaurantAsset.pdf
        this.assetNames = this.theme.restaurantAsset.pdfName
        this.assetUrls = this.theme.restaurantAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.restaurantAsset.videos
        this.assetNames = this.theme.restaurantAsset.videosName
      }
    } else if (this.assetType === 'Office Teaser 10k') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.officeAsset.videos
        this.assetNames = this.theme.officeAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.officeAsset.floorplans
        this.assetNames = this.theme.officeAsset.floorplansName
        this.assetUrls = this.theme.officeAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.officeAsset.panoramas
        this.assetNames = this.theme.officeAsset.panoramasName
        this.assetUrls = this.theme.officeAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.officeAsset.balcony
        this.assetNames = this.theme.officeAsset.balconyName
        this.assetUrls = this.theme.officeAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.officeAsset.renders
        this.assetNames = this.theme.officeAsset.rendersName
        this.assetUrls = this.theme.officeAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.officeAsset.range
        this.assetNames = this.theme.officeAsset.rangeName
        this.assetUrls = this.theme.officeAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.officeAsset.pdf
        this.assetNames = this.theme.officeAsset.pdfName
        this.assetUrls = this.theme.officeAsset.pdfUrl
      } else if (this.viewType === 'socials') {
        this.assetOrder = this.theme.officeAsset.videos
        this.assetNames = this.theme.officeAsset.videosName
      }
    }

    BunnyNetService.getRenders(this.folderStructure, this.assetType)
    .then(response => {
      let j = 0;
      // Remap array

      console.log(response.data);
      
      const menuItems = response.data.map((item) => {
        if (this.assetUrls && this.assetUrls.length >= 1){
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: this.assetNames[j],
            url: this.assetUrls[j],
            id: j++
          };
        } else {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: unslugify(item.ObjectName.split('.').slice(0,-1).join(".")).replace("hyphen","-"),
            url: [],
            id: j++
          };
        }
      });

      // Custom order array based on section and type
      if( this.assetOrder && this.assetOrder.length >= 1 ) {
        this.assetTypes = this.reorder(menuItems, this.assetOrder);
      } else {
        this.assetTypes = menuItems
      }

      this.assetTypesReady = true
      if (this.viewType == "pdf"){
        setTimeout( () => {
                if (this.adobeApiPDFReady == true){
                    console.log("It is ready")
                    console.log(this.assetUrls[this.order])
                    this.initialisePdf(this.assetUrls[this.order], this.assetNames[this.order])
                    // this.initialisePdf("https://developmentprog.com/pdf1.pdf", "Florian Brochure")
                }
            },
            "1000"
        )
      }
    })
  },
  methods: {
    // Reorder array based on config setup
    reorder: function(data_array, real_order) {
      var i, d = {}, result = [];
      for(i=0; i<data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for(i=0; i<real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    },
    initialisePdf: function(pdfLink, pdfName){
        this.adobeDCView.previewFile({
            content: {location: {url: pdfLink}},
            metaData: { fileName: pdfName },
        }, {embedMode: "IN_LINE", showDownloadPDF: false, showPrintPDF: false});
    },
  },
  setup () {
    const {theme} = global

    return {
      theme
    }
  },
  mounted() {
        document.addEventListener("adobe_dc_view_sdk.ready", () => {
            this.adobeApiPDFReady = true;
            console.log("Adobe created with adobe_dc_view_sdk.ready");
        });

        // Dynamically load Adobe SDK Viewer for this page
        const plugin = document.createElement("script");
        plugin.setAttribute(
            "src",
            "https://documentcloud.adobe.com/view-sdk/viewer.js"
        );
        plugin.async = true;
        document.head.appendChild(plugin);
    },
    watch: {
        adobeApiPDFReady(val) {
            if (val) {
                let view = new window.AdobeDC.View({
                    clientId: "d61f95f324b548daa6555fad9f3e09f3",
                    divId: "pdf-view-inline",
                });
                this.adobeDCView = Object.freeze(view);
                console.log("Adobe is mounted with Client ID");
            }
        },
    }
}
</script>